module.exports = __webpack_public_path__ + "img/hardware.7028f662.svg";